/**
 * Uygulama açılırken (React render etmeden önce) sunucudan gelen statik
 * HTML'deki canonical linkini yakalar. Prerender edilmiş sayfalarda canonical
 * o sayfanın kendi yoludur; SPA kabuğunda (index.html fallback) canonical yoktur.
 *
 * Kullanım amacı: Firestore sorgusu veri döndürmediğinde "sayfa gerçekten yok"
 * ile "veri okunamadı" durumunu ayırmak. Prerender edilmiş bir rota için asla
 * noindex 404 basılmamalı — GSC'deki "Excluded by 'noindex' tag" hatalarının
 * kökü, Googlebot JS render'ında geçerli sayfalara noindex basılmasıydı.
 */

const initialCanonicalPath: string | null = (() => {
  try {
    const link = document.querySelector('link[rel="canonical"]');
    const href = link?.getAttribute("href");
    if (!href) return null;
    return new URL(href, window.location.origin).pathname;
  } catch {
    return null;
  }
})();

/** İlk yüklenen statik HTML bu yol için prerender edilmiş miydi? */
export function wasPrerenderedFor(pathname: string): boolean {
  if (!initialCanonicalPath) return false;
  const norm = (p: string) => p.replace(/\/+$/, "") || "/";
  return norm(initialCanonicalPath) === norm(pathname);
}
